

import request from '@/utils/request'
// 获取专题页详情
export function getTopicDetail(params) {
    return request({
        url: '/v1/project/detail',
        method: 'get',
        params,
    })
}
// 获取专题页商品
export function getTopicGoods(params) {
    return request({
        url: '/v1/project/getGoodsList',
        method: 'get',
        params,
    })
}